// @ts-nocheck

import { type StateType } from '../../../states';
import { type EntitiesGrids } from '../../../states/entities/grids';
import Grid from '../states/grid';
import { type GridState } from '../types';

export const getGrids = (state: StateType): EntitiesGrids => {
  return state.entities.grids;
};

export const getGrid = (state: StateType, gridReference: string | null): GridState | null => {
  if (gridReference) {
    const grids = getGrids(state);
    return grids[gridReference];
  }
  return null;
};

export const getGridTotalAmount = (state: StateType, gridReference: string): number => {
  const grid = getGrid(state, gridReference);
  return Grid.getAmount(grid);
};

export const getIsProgressBarFilled = (state: StateType, gridReference: string | null): boolean => {
  const grid = getGrid(state, gridReference);
  if (grid) {
    const gridAmount = Grid.getAmount(grid);
    const { allBetAmount } = grid;
    return gridAmount === allBetAmount;
  }
  return false;
};
